import type { CSSProperties } from 'react';
import { pxToRem } from '@/theme/spacing';

const MARKDOWN_BLOCK_GAP_PX = 12;

interface CreateMarkdownFlowStyleInput {
  alignItems: CSSProperties['alignItems'];
  style?: CSSProperties;
}

export function createMarkdownFlowStyle({
  alignItems,
  style,
}: CreateMarkdownFlowStyleInput): CSSProperties {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems,
    rowGap: pxToRem(MARKDOWN_BLOCK_GAP_PX),
    width: '100%',
    ...style,
  };
}
